








import { defineComponent } from '@vue/composition-api';

import PanelWithMaterialPurchaseRequestEditor from '@/components/PurchaseRequest/PanelWithMaterialPurchaseRequestEditor.vue';

const CreateProduction = defineComponent({
  components: { PanelWithMaterialPurchaseRequestEditor },
  // setup() {},
});

export default CreateProduction;
